/**
 * @generated SignedSource<<df5792a8e2f24ede44bbc7f79eb21052>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCheckoutPixAutomatic_checkout$data = {
  readonly active: boolean | null | undefined;
  readonly company: {
    readonly nameFriendly: string | null | undefined;
    readonly projectType: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"PaymentCheckoutCompanyData_company" | "PaymentCompanyLogo_company" | "PaymentCompanySupport_company">;
  } | null | undefined;
  readonly id: string;
  readonly type: string | null | undefined;
  readonly value: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCheckoutDeactivated_checkout" | "PaymentCheckoutHeading_checkout" | "PaymentCheckoutMethods_checkout" | "PaymentCheckoutPixAutomaticForm_checkout" | "PaymentCheckoutPixAutomaticInfo_subscription" | "PaymentCheckoutTitle_checkout">;
  readonly " $fragmentType": "PaymentCheckoutPixAutomatic_checkout";
};
export type PaymentCheckoutPixAutomatic_checkout$key = {
  readonly " $data"?: PaymentCheckoutPixAutomatic_checkout$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCheckoutPixAutomatic_checkout">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCheckoutPixAutomatic_checkout",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentCompanyLogo_company"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentCheckoutCompanyData_company"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentCompanySupport_company"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCheckoutHeading_checkout"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCheckoutTitle_checkout"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCheckoutMethods_checkout"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCheckoutDeactivated_checkout"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCheckoutPixAutomaticInfo_subscription"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCheckoutPixAutomaticForm_checkout"
    }
  ],
  "type": "Checkout",
  "abstractKey": null
};

(node as any).hash = "a12eee59f68f64f4a02f13211a21c9d0";

export default node;
